import { useI18nContext } from "@hopper-b2b/i18n";
import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import {
  CoreUiComponents,
  PlatformComponentProps,
} from "@b2bportal/core-types";
import defaultStyles from "./PageFooter.module.scss";
import clsx from "clsx";

export interface PageFooterComponentProps extends PlatformComponentProps {}

export const PageFooter = ({
  children,
  className,
}: PageFooterComponentProps) => {
  const { t } = useI18nContext();
  const styles = useUiStyles(CoreUiComponents.PageFooter, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.PageFooter);
  return (
    <div className={clsx(block, className)}>
      <span className={cn("copyright")}>{`© ${new Date().getFullYear()} ${t(
        "portalName"
      )}`}</span>
      {children}
    </div>
  );
};
